import { render, staticRenderFns } from "./SubmitTemplateForBrands.vue?vue&type=template&id=2bd95c7b&"
import script from "./SubmitTemplateForBrands.vue?vue&type=script&lang=js&"
export * from "./SubmitTemplateForBrands.vue?vue&type=script&lang=js&"
import style0 from "./SubmitTemplateForBrands.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports